import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadData as loadFavorites } from './FavoritesPage.duck';
import ListingCard from '../../components/ListingCard/ListingCard';
import css from './FavoritesPage.module.css';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { useIntl } from 'react-intl';
import { getListingsById } from '../../ducks/marketplaceData.duck';

const FavoritesPage = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'FavoritesPage.title' });
  const scrollingDisabled = useSelector(isScrollingDisabled);

  const favoriteIds = useSelector(
    state => state.user.currentUser?.attributes?.profile?.publicData.favorites || []
  );

  const {
    currentPageResultIds = [],
    isLoading = false,
    error = null,
  } = useSelector(state => state.favorites);

  const listings = useSelector(state =>
    getListingsById(state, currentPageResultIds)
  );


  useEffect(() => {
    dispatch(loadFavorites());
  }, [dispatch]);

  const filteredItems = listings.filter(l => favoriteIds.includes(l.id.uuid));


  // Loading
  if (isLoading) {
    return (
      <Page title={title} scrollingDisabled={scrollingDisabled}>
        <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
          <div className={css.favoritesPage}>
            <div className={css.fixedWidthContainer}>
              <div className={css.loading}>Loading your favorites…</div>
            </div>
          </div>
        </LayoutSingleColumn>
      </Page>
    );
  }

  // Error
  if (error) {
    const errMsg = error.message || JSON.stringify(error);
    return (
      <Page title={title} scrollingDisabled={scrollingDisabled}>
        <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
          <div className={css.favoritesPage}>
            <div className={css.fixedWidthContainer}>
              <div className={css.error}>Error loading favorites: {errMsg}</div>
            </div>
          </div>
        </LayoutSingleColumn>
      </Page>
    );
  }

  // Empty
  if (filteredItems.length === 0) {
    return (
      <Page title={title} scrollingDisabled={scrollingDisabled}>
        <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
          <div className={css.favoritesPage}>
            <div className={css.fixedWidthContainer}>
              <div className={css.empty}>
                {favoriteIds.length === 0
                  ? 'You have no favorites yet.'
                  : 'No matching listings found in your favorites.'}
              </div>
            </div>
          </div>
        </LayoutSingleColumn>
      </Page>
    );
  }

  // Data
  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.favoritesPage}>
          <div className={css.fixedWidthContainer}>
            <h1>My Favorites</h1>
            <div className={css.listingsPanel}>
              {filteredItems.map(listing => (
                <ListingCard
                  key={listing.id.uuid}
                  listing={listing}
                  renderSizes="(max-width: 400px) 100vw, 33vw"
                  showAuthorInfo
                />
              ))}
            </div>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default FavoritesPage;
